import {
    Button,
    BUTTON_TYPES,
    Flex,
    IconCheckmarkCircle,
    mediaMixin,
    Paragraph,
    spaceMixin,
    token,
} from '@zillow/constellation';
import React from 'react';
import styled, { css } from 'styled-components';
import { getCopy } from '../utils/copyUtils';
import type { SuccessContentProps } from '../types/@zillow-types';

export const SuccessMessageWrapper = styled(Flex)`
    margin: 0px auto;
    max-width: 470px;
`;

const StyledIconCheckmarkCircle = styled(IconCheckmarkCircle)`
    // increase specificity so DsExpandableCard in HDC doesn't override :(
    && {
        color: ${token('colors.green400')};
        width: 77px;
        height: 77px;
        margin-bottom: ${spaceMixin('xs')};
    }
`;

const StyledButton = styled(Button)`
    width: 100%;
    margin-top: ${spaceMixin('md')};
    ${mediaMixin(
        'md',
        css`
            max-width: 350px;
        `
    )}
`;

const StyledConfirmationNote = styled(Paragraph)`
    max-width: 500px;
    ${mediaMixin(
        'md',
        css`
            text-align: center;
        `
    )}
`;

const SuccessContent = ({
    onClose,
    shouldShowPrimaryCloseButton,
    contactFormVersion,
}: SuccessContentProps) => (
    <SuccessMessageWrapper
        data-testid="om-contact-agent-success"
        display="flex"
        flexDirection="column"
        alignItems="center"
    >
        <StyledIconCheckmarkCircle />
        <Paragraph fontType="h6">{getCopy(contactFormVersion, 'successTitle')}</Paragraph>
        <StyledConfirmationNote marginTop="sm">
            {getCopy(contactFormVersion, 'successBody')}
        </StyledConfirmationNote>
        {shouldShowPrimaryCloseButton && (
            <StyledButton
                data-testid="contact-agent-primary-close"
                buttonType={BUTTON_TYPES.primary}
                onClick={onClose}
            >
                Close
            </StyledButton>
        )}
    </SuccessMessageWrapper>
);

export default SuccessContent;
